import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';

import { Resource } from '../../../httpClient/resources/Resource';
import { GetSiteNamesAcrossAllPodsRequest, IGetSiteNamesAcrossAllPodsResult } from '../../serverApi/requests/GetSiteNamesAcrossAllPodsRequest';
import { ISiteNameSansId } from '../../serverApi/types/ISiteNameSansId';

export class SiteNameSansIds extends Resource<ISiteNameSansId> {

  public static readonly instance = new SiteNameSansIds(new WebClientListResourceFetcher(GetSiteNamesAcrossAllPodsRequest, (result: IGetSiteNamesAcrossAllPodsResult) => {
    if (result.errors) {
      return [];
    }
    return result.siteNames;
  }));

}
